import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router, RouterLink} from "@angular/router";
import {
  faBars,
  faBorderAll,
  faBuilding,
  faGear,
  faNetworkWired,
  faProjectDiagram,
  faUsers,
} from "@fortawesome/pro-solid-svg-icons";
import {LoadingService} from "../../../../services/loading/loading.service";
import {StateConfigService} from "../../../../services/state/state-config.service";
import {
  OrganisationPopupComponent
} from "../../../organisations/components/organisation-popup/organisation-popup.component";
import {MatDialog} from "@angular/material/dialog";
import {NgClass, NgTemplateOutlet} from '@angular/common';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {TooltipDirective} from '@buildinginformationcloud/bic-ui-components';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, NgTemplateOutlet, FaIconComponent, RouterLink, TooltipDirective]
})
export class NavbarComponent implements OnInit {
  loadingService = inject(LoadingService);
  stateService = inject(StateConfigService);
  private router = inject(Router);
  private dialog = inject(MatDialog);


  hovering: boolean = false;
  hoveringOrga: boolean = false;

  /**
   * Ohne Organisation bzw. Persoenlich-Kontext gibt es keine Projektliste, die angezeigt
   * werden koennte - der Eintrag ist dann gesperrt statt in eine leere Uebersicht zu fuehren.
   */
  get projectOverviewBlocked(): boolean {
    return !this.stateService.getOrganisationIdOrUndefined() && !this.stateService.isPersonal;
  }

  ngOnInit(): void {

  }

  protected readonly faBars = faBars;
  protected readonly faProjectDiagram = faProjectDiagram;
  protected readonly faGear = faGear;
  protected readonly faBorderAll = faBorderAll;

  openNewOrganisation(){
    let ref = this.dialog.open(OrganisationPopupComponent, {
      panelClass: 'rounded-corners-dialog',
      data: {
        title: "Neues Unternehmen"
      },
      width: '60%',
      autoFocus: false
    });
  }

  test(entering: boolean){
    this.hovering = entering;
  }

  openEditOrganisation(organisationId: number){
    let ref = this.dialog.open(OrganisationPopupComponent, {
      panelClass: 'rounded-corners-dialog',
      data: {
        organisationId: organisationId,
        title: "Unternehmenseinstellungen"
      },
      width: '60%',
    });
  }

  openProjectOverview(){
    if (this.projectOverviewBlocked) {
      return;
    }
    this.stateService.selectProject(undefined);
  }

    routeToOrganisations(){
    this.stateService.selectProject(undefined, false);
    this.stateService.selectOrganisation(undefined, true, false, true);
  }

  protected readonly faNetworkWired = faNetworkWired;
  protected readonly faBuilding = faBuilding;
  protected readonly faUsers = faUsers;
}
